<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <span class="sa-flexbox-body-title">Progetto: Socio Riabilitativo</span>
                <!--secondary btn-toolbar sa-margin-right float-sm-right-->
                <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" :hidden="btnAggiungi" @click="onClickAggiungi" class="mb-2">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                </b-button>
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(operatore)="{ item }">
                        <span>{{ item.operatore }}</span>
                    </template>
                    <template v-slot:cell(dataInizio)="{ item }">
                        <span>{{ formatDate(item.dataInizio) }}</span>
                    </template>
                    <template v-slot:cell(dataFine)="{ item }">
                        <span>{{ formatDate(item.dataFine) }}</span>
                    </template>
                    <template #cell(action)="{ item }">
                        <b-container class="bv-example-row">
                            <print-component v-if="false" :documentRepository="true" :idRisorsa="item.id" :typeButton="'small'"> </print-component>
                            <!-- <b-button size="sm" variant="outline-secondary" @click="onClickStampa(item)" title="Visualizza">
                                <font-awesome-icon icon="eye"  color="red"/>
                            </b-button> -->
                            <b-button size="sm" variant="outline-secondary" @click="onClickVisualizzaScheda(item)" title="Visualizza">
                                <font-awesome-icon icon="eye" />
                            </b-button>
                            <!-- :disabled="!item.tipoScheda || item.tipoScheda.trim() !== 'SCHEDA RELAZIONE SANITARIA'"  -->
                            <b-button size="sm" variant="outline-success" @click="onClickModificaScheda(item)" title="Modifica">
                                <font-awesome-icon icon="edit" />
                            </b-button>
                            <b-button size="sm" variant="outline-danger" @click="onClickDeleteScheda(item)" title="Elimina">
                                <font-awesome-icon icon="trash" />
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <rsa-paziente-socio-riabilitativo-modal-edit ref="cmpRsaPazienteSocioRiabilitativoModal" @afterSave="onAfterSave"></rsa-paziente-socio-riabilitativo-modal-edit>
        <!-- <print-component v-show="false" ref="cmpPrint"></print-component> -->
        <modal-error ref="cmpModalError"></modal-error>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import RsaPazienteSocioRiabilitativoModalEdit from "./RsaPazienteSocioRiabilitativoModalEdit.vue";
export default {
    mixins: [UtilityMixin],
    components: { RsaPazienteSocioRiabilitativoModalEdit, PrintComponent, ModalError },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsapazientesrtestata",
            btnAggiungi: false,
            filtroProgettoSocioRiabilitativo: { idAccettazione: null },
            idAccettazione: "",
            items: [],
            fields: [
                {
                    label: "Nome Progetto",
                    key: "nomeProgetto",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Data Fine",
                    key: "dataFine",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Operatore",
                    key: "operatore",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "",
                    key: "action",
                    class: "sa-table-column-action-double",
                },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        init(idAccettazione) {
            let me = this;
            me.idAccettazione = idAccettazione;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroProgettoSocioRiabilitativo"]) {
                me.filtroProgettoSocioRiabilitativo = JSON.parse(sessionStorage["filtroProgettoSocioRiabilitativo"]);
            }
            me.filtroProgettoSocioRiabilitativo.idAccettazione = me.idAccettazione;
            me.filtroProgettoSocioRiabilitativo.page = me.currentPage;
            me.filtroProgettoSocioRiabilitativo.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroProgettoSocioRiabilitativo, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.log(error);
            me.$emit("afterLoadData");
        },
        onClickAggiungi() {
            let me = this;

            let url = process.env.VUE_APP_PATH_API + "/rsaaccettazioni/" + me.idAccettazione;

            axios
                .get(url)
                .then((response) => {
                    let accettazione = response.data.data;
                    if (accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" || accettazione.statoAttuale === "ASSENTE" || accettazione.statoAttuale === "SOSPESO_ADI") {
                        let messaggio = accettazione.statoAttuale === "SOSPESO_ADI" ? "Non è possibile questa operazione su un paziente con percorso ADI sospeso" : accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                        me.$bvModal.msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        });
                        return;
                    } else {
                        me.$refs.cmpRsaPazienteSocioRiabilitativoModal.show(me.idAccettazione);
                    }
                })
                .catch((error) => {
                    console.error("Errore nel recupero dati accettazione:", error);
                    me.$bvToast.toast("Errore nel recupero dei dati del paziente.", {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },

        onClickModificaScheda(item) {
            let me = this;
            me.$refs.cmpRsaPazienteSocioRiabilitativoModal.modificaScheda(item);
        },
        onClickVisualizzaScheda(item) {
            let me = this;
            me.$refs.cmpRsaPazienteSocioRiabilitativoModal.visualizzaScheda(item);
        },
        onAfterSave() {
            let me = this;

            me.loadData();
        },
        onClickDeleteScheda(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Scheda",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteScheda(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteScheda(id) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
            axios
                .delete(link)
                .then((response) => {
                    me.loadData();
                    me.showModalLoading = false;
                    me.$emit("onDelete", response);
                    me.$bvToast.toast("Eliminazione avvenuta con successo", {
                        title: "Successo",
                        variant: "success",
                        solid: true,
                    });
                })
                .catch((e) => {
                    console.log(e);
                    me.showModalLoading = false;
                    me.$bvToast.toast("Errore durante l'eliminazione", {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
        // linkPrintData(item) {
        //     return "/rsaprintdata?idRisorsa=" + item.id + "&idAccettazione=" + item.idAccettazione + "&printDataObjectName=" + item.tipoScheda;
        // },
        onClickStampa(item) {
            let me = this;
            let path = me.getPathResourcesPrint(item.tipoScheda);
            me.loadDataResources(path + "/printdata/" + item.id, null, me.resulResponseStampa, me.resulErrorStampa);
        },
        resulResponseStampa(response) {
            let me = this;
            me.$refs.cmpPrint.print(response.data.data);
        },
        resulErrorStampa(error) {
            console.log(error);

            // let messaggio = "errore";
        },
        getPathResourcesPrint(tipoScheda) {
            let returnValue = "";
            switch (tipoScheda) {
                case "ANAMNESI / STORIA CLINICA":
                    returnValue = "/rsaanamnesistoriaclinica";
                    break;
                case "AREA MOBILITA'":
                    returnValue = "/rsaareamobilita";
                    break;
                case "SCHEDA STATI VEGETATIVI":
                    returnValue = "/rsaschedevalutazioneallegatoa";
                    break;
                case "SCHEDA PSICOLOGICA":
                    returnValue = "/rsaschedapsicologica";
                    break;
                case "SCHEDA SOCIALE":
                    returnValue = "/rsaschedasocialepaziente";
                    break;
                case "ESAME OBIETTIVO GENERALE":
                    returnValue = "/rsaschedaesameobiettivogenerale";
                    break;
                case "RIFERIMENTI DIAGNOSTICI":
                    returnValue = "/rsaschedariferimentidiagnostici";
                    break;
                case "SCHEDA INFERMIERISTICA":
                    returnValue = "/rsaschedainfermieristica";
                    break;
            }
            return returnValue;
        },
    },
};
</script>

<style></style>
